import React from 'react'

const WidgetAlarm = ({ ...props }) => {
  return (
    <i className="icon-widget-alarm" {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.69296 1.32029C8.38504 0.786962 7.61525 0.786958 7.30732 1.32029L0.195285 13.6385C-0.11264 14.1718 0.272259 14.8385 0.888102 14.8385H15.112C15.7279 14.8385 16.1128 14.1718 15.8048 13.6385L8.69296 1.32029Z"
          fill="#FFC247"
        />
        <mask
          id="mask0_524_10938"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="15">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.69296 1.32029C8.38504 0.786962 7.61525 0.786958 7.30732 1.32029L0.195285 13.6385C-0.11264 14.1718 0.272259 14.8385 0.888102 14.8385H15.112C15.7279 14.8385 16.1128 14.1718 15.8048 13.6385L8.69296 1.32029Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_524_10938)">
          <rect width="16" height="16" fill="#F34C39" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.375 10.0917C7.375 10.3069 7.65469 10.4813 8 10.4813C8.34531 10.4813 8.625 10.3069 8.625 10.0917V5.27082C8.625 5.05559 8.34531 4.88126 8 4.88126C7.65469 4.88126 7.375 5.05559 7.375 5.27082V10.0917ZM8 13.7031C7.61167 13.7031 7.29688 13.3883 7.29688 13C7.29688 12.6117 7.61167 12.2969 8 12.2969C8.38833 12.2969 8.70312 12.6117 8.70312 13C8.70312 13.3883 8.38833 13.7031 8 13.7031Z"
            fill="white"
          />
          <path
            d="M8 10.0813C7.89006 10.0813 7.80967 10.0527 7.76959 10.0277C7.72381 9.99919 7.775 10.0112 7.775 10.0917H6.975C6.975 10.3874 7.16603 10.5942 7.34642 10.7066C7.53252 10.8226 7.76463 10.8813 8 10.8813V10.0813ZM8.225 10.0917C8.225 10.0112 8.27619 9.99919 8.23041 10.0277C8.19033 10.0527 8.10994 10.0813 8 10.0813V10.8813C8.23537 10.8813 8.46748 10.8226 8.65358 10.7066C8.83397 10.5942 9.025 10.3874 9.025 10.0917H8.225ZM8.225 5.27082V10.0917H9.025V5.27082H8.225ZM8 5.28126C8.10994 5.28126 8.19033 5.30981 8.23041 5.33478C8.27619 5.36332 8.225 5.35132 8.225 5.27082H9.025C9.025 4.97509 8.83397 4.76831 8.65358 4.65587C8.46748 4.53987 8.23537 4.48126 8 4.48126V5.28126ZM7.775 5.27082C7.775 5.35132 7.72381 5.36332 7.76959 5.33478C7.80967 5.30981 7.89006 5.28126 8 5.28126V4.48126C7.76463 4.48126 7.53252 4.53987 7.34642 4.65587C7.16603 4.76831 6.975 4.97509 6.975 5.27082H7.775ZM7.775 10.0917V5.27082H6.975V10.0917H7.775ZM6.89687 13C6.89687 13.6092 7.39076 14.1031 8 14.1031V13.3031C7.83259 13.3031 7.69688 13.1674 7.69688 13H6.89687ZM8 11.8969C7.39076 11.8969 6.89687 12.3908 6.89687 13H7.69688C7.69688 12.8326 7.83259 12.6969 8 12.6969V11.8969ZM9.10312 13C9.10312 12.3908 8.60924 11.8969 8 11.8969V12.6969C8.16741 12.6969 8.30313 12.8326 8.30313 13H9.10312ZM8 14.1031C8.60924 14.1031 9.10312 13.6092 9.10312 13H8.30313C8.30313 13.1674 8.16741 13.3031 8 13.3031V14.1031Z"
            fill="white"
          />
        </g>
      </svg>
    </i>
  )
}

export default WidgetAlarm
